<!-- App.vue -->

<template>
  <router-view></router-view>
</template>
<script setup>
import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { PostLoginToken, PostUserInfo, getCheckUser } from "@/api/index.js";
import { useUserStore } from "@/views/stores/order"; // 引入用户store
import { Cookie } from "@/utils/Cookie";
import { ElMessage } from "element-plus";
const router = useRouter();
const userStore = useUserStore();
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});
const postCheckUserWithHeartbeat = async () => {
    const token = JSON.parse(Cookie.get("token")) || "";
    // console.log(token,'token');
console.log('登录之后操作');


    if (token) {
        try {
    const res = await getCheckUser();
    if (res.info.result === "SUCCESSED") {
      return;
    } else{
      Cookie.remove("userInfo");
      Cookie.remove("token");
      Cookie.remove("checkIP_login");
  //       bus.emit("isloginStatus", {
  //       message: "登录状态",

  
  // });
    }
    // console.log(res, '心跳检测结果');
  } catch (error) {
    // console.log("心跳检测失败:", error);
  } finally {
    // 无论成功/失败，5秒后再次执行
    setTimeout(postCheckUserWithHeartbeat, 300000);
  }
};
    }


// 启动心跳检测
// postCheckUserWithHeartbeat();
/**
 * 检查Token状态并执行相应操作
 */
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";

  // 1. Token不存在的情况
  if (!token) {
    await callTokenCheckApi();
    return;
  }

  // 2. Token存在但过期的情况
  if (isTokenExpired(token)) {
    await callTokenCheckApi();
  }

  // 3. Token有效的情况不做任何操作
};

/**
 * 检查Token是否过期
 */
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};

/**
 * 调用Token检查接口
 */
const callTokenCheckApi = async () => {
  try {
    // 替换成你实际的Token检查接口
    const res = await PostLoginToken();
    if (res.info.token && res.info.result === "SUCCESSED") {
      // localStorage.setItem("token", res.info.token);
      Cookie.set("token", JSON.stringify(res.info.token));

       const resinfo = await PostUserInfo();
      const token = res.info.token;
      if (resinfo.info) {
        userStore.setUserInfo(token, resinfo.info);
      }
    } else {
    }
  
    // 接口调用成功后的处理（如果有）
  } catch (error) {
    console.log("Token检查接口调用失败:", error);
    // 接口调用失败的处理（如果有）
  }
};

// const bodyScale= ()=> {
//     let devicewidth = document.documentElement.clientWidth //获取当前分辨率下的可是区域宽度
//     let scale = devicewidth / 1920 // 分母——设计稿的尺寸
//     document.body.style.zoom = scale //放大缩小相应倍数
// }

// 监听路由变化
watch(
  () => router.currentRoute.value,
  async () => {
    await checkTokenStatus();
  },
  { immediate: true }
);

// 初始化检查
onMounted(async () => {
  await checkTokenStatus();
  await postCheckUserWithHeartbeat()
  // const _this = this;
  // bodyScale();
  // window.onresize = function() {
  //     bodyScale();
  // }.bind(this);
});
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
}  

:root {
  --safe-area-width: 1400px; 
}

/* 安全域内容（所有端通用） */
.safe-content {
  width: 100%;
  max-width: var(--safe-area-width);
  margin: 0 auto;
  
}

/* 通栏外层包裹（所有端通用） */
.full-width {
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

/* 通栏内层内容（可选对齐安全域） */
.full-width__inner {
  max-width: var(--safe-area-width);
  margin: 0 auto;
  /* padding: 0 20px;  */
}

/* =============== 媒体查询（三端适配） =============== */
/* 1. 平板端（768px ~ 1024px） */
@media (min-width: 768px) and (max-width: 1024px) {
  :root {
    --safe-area-width: 90%; /* 平板用百分比更灵活 */
  }
  .safe-content,
  .full-width__inner {
    padding: 0 15px; /* 平板内边距稍小 */
  }
}

/* 2. 手机端（≤ 767px） */
@media (max-width: 767px) {
  :root {
    --safe-area-width: 100%; /* 手机端全宽 */
  }
  .safe-content,
  .full-width__inner {
    padding: 0 12px; /* 手机内边距最小 */
  }

  /* 手机端通栏修复（禁用横向偏移） */
  .full-width {
    left: 0;
    transform: none;
  }
}

/* 3. 超大 PC 端（≥ 1400px） */
@media (min-width: 1400px) {
  :root {
    --safe-area-width: 1400px; /* 明确固定值 */
  }
}
</style>
